<template>
  <div class="auctions">
    <div class="media-box">
      <h2 data-aos="fade-up" data-aos-delay="100">{{$t('infoBox.newsTitle')}}</h2>
      <div  v-if="lang === 'pl'" v-for="(item, index) in news" :key="item.title+index" data-aos="fade-up" class="news-container">
        <div class="foto" v-if="item.img">
          <img :src="item.img" :alt="item.title"/>
        </div>

        <div>
          <div class="title" v-html="item.title"></div>
          <div class="info" v-html="item.body"></div>
          <div class="posted">
            <p class="par_posted">{{ $t('infoBox.postedDescription') }} {{item.date}}</p>
          </div>
        </div>

      </div>


      <div  v-if="lang !== 'pl'" v-for="(item, index) in news_en" :key="item.title+index" data-aos="fade-up" class="news-container">
        <div class="foto" v-if="item.img">
          <img :src="item.img" :alt="item.title"/>
        </div>

        <div>
          <div class="title" v-html="item.title"></div>
          <div class="info" v-html="item.body"></div>
          <div class="posted">
            <p class="par_posted">{{ $t('infoBox.postedDescription') }} {{item.date}} </p>
          </div>
        </div>

      </div>

      <div v-for="(item, index) in $t('infoBox.infoBoxes')" :key="index" data-aos="fade-up" class="news-container">
        <div class="foto" v-if="item.img">
          <img :src="item.img" :alt="item.title"/>
        </div>
        <div>
          <div class="title" v-html="item.title"></div>
          <div class="info" v-html="item.text"></div>
          <div class="video-container" v-if="item.video">
            <video :src="item.video" :poster="item.poster" controls></video>
          </div>

          <div v-if="item.link" class="link">{{ $t('infoBox.linkDescription') }}
            <a :href="item.link" target="_blank">
              <i class="fas fa-link"></i>
            </a>
          </div>
          <div class="posted">
            <p class="par_posted">{{ $t('infoBox.postedDescription') }} {{item.date}} </p>
          </div>
        </div>
        <hr class="separate"/>
      </div>

      <!-- archiwum -->
      <vs-collapse>
        <vs-collapse-item :not-arrow='true'>
          <div slot="header">
            <h3 data-aos="fade-up" data-aos-delay="250" class="archive">
              <i class="fas fa-angle-double-right"></i>&emsp;{{$t('infoBox.archiveTitle')}}&emsp;<i
              class="fas fa-angle-double-left"></i>
            </h3>
          </div>

          <div class="media-box centered">
            <a v-for="(item, index) in $t('mediaBox.mediaBoxes')" :key="index" :class="['box', item.type]"
               target="_blank" :href="item.link" data-aos="fade-up">
              <div class="image">
                <div class="img" :style="{ backgroundImage: 'url(' + item.img + ')' }"></div>
              </div>
              <div class="text">
                <span>{{item.title}}</span>
                <p v-html="item.text"></p>
              </div>
            </a>
          </div>

        </vs-collapse-item>
      </vs-collapse>


    </div>
    <footer-main/>
  </div>

</template>

<script>
  import store from '../store/store';
  import FooterMain from '../components/FooterMain';

  export default {
    name: 'news',
    components: {
      FooterMain
    },
    data() {
      return {
        news: [],
        news_en: []
      }
    },
    methods: {
      async getData() {
        try {
          const response = await this.$http.get(
            "/data/posts.json"
          );

          this.news = response.data
            .map(el => {
              let img =null;

              try{
                img = el._embedded['wp:featuredmedia']['0'].source_url
              }catch (e) {

              }
              return ({
                t: new Date(el.data_newsa).getTime(),
                date: el.data_newsa,
                body: el.content.rendered,
                title: el.title.rendered,
                img
              })
            })
            .sort((a,b) => b.t-a.t);
        } catch (error) {
          console.log(error);
        }

        try {
          const response = await this.$http.get(
            "/data/posts_en.json"
          );

          this.news_en = response.data
            .map(el => {
              let img =null;

              try{
                img = el._embedded['wp:featuredmedia']['0'].source_url
              }catch (e) {

              }
              return ({
                t: new Date(el.data_newsa).getTime(),
                date: el.data_newsa,
                body: el.content.rendered,
                title: el.title.rendered,
                img
              })
            })
            .sort((a,b) => b.t-a.t);
        } catch (error) {
          console.log(error);
        }
      }
    },
    computed: {
      lang: () => {
        return store.state.lang;
      }
    },
    mounted () {
      this.getData();
    }
  }
</script>

<style scoped>
  @import "https://use.fontawesome.com/releases/v5.7.1/css/all.css";


  .video-container video {
    max-width: 80%;
    padding: 5px;
    max-height: 80vh;
  }

  .auctions {
    overflow: hidden;
  }

  .news {
    margin-top: -250px;
  }

  .info {
    text-align: left;
    line-height: 1.4em;
  }

  .title {
    font-weight: bold;
    font-family: "Ubuntu Bold";
    margin-top: 30px;
    margin-bottom: 10px;
  }

  .strong {
    font-family: "Ubuntu Bold";
  }

  .archive {
    margin-top: 50px;
  }

  .link {
    margin-top: 10px;
    color: #e74011;

  }

  .foto {
    padding: 5px;
    margin-right: 20px;
    float: left;
    margin-top: 20px;
  }

  .foto img {
    max-width: 230px;
  }

  .separate {
    clear: both;
    width: 300px;
    position: relative;
    top: 50%;
    left: 50%;
    /* bring your own prefixes */
    transform: translate(-50%, -50%);
  }

  .centered {
    text-align: center;

  }

  .posted {
    margin-top: 20px;

  }

  .par_posted {
    font-size: 0.8rem;
    font-style: italic;
  }

  .media-box .news-container {
    display: flex;
    flex-direction: row;
  }

  @media (max-width: 700px) {
    .media-box .news-container {
      flex-direction: column;
    }
    .foto img{
      max-width: 320px;
      width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// Infonews.vue?711aadae